/**
 * Tutorial
 *  
 * HTML authors need to do the following:
 * * Apply this class to the parent element: "js-carousel" and "js-tutorial"
 * * Apply this class on each container that needs to update dynamically: "js-carousel-view"
 * * Apply this class on each item that would change in the view: "js-carousel-item"
 */

import Carousel from './Carousel';
import Carousels from './Carousels';

const cssClasses = {
    activeMenuItem: 'CMSListMenuHighlightedLI',
    inactiveMenuItem: 'CMSListMenuLI',
    tutorial: 'js-tutorial',
    tutorialItem: 'js-tutorial-item',
};

const dataAttrs = {
    menuUrl: 'menuurl',
};

const domIds = {
    mainNavigationRoot: 'MainNavigation',
};

const selectors = {
    actualCurrentNavigationElement: '#MainNavigation .CMSListMenuHighlightedLI',
};

class Tutorial extends Carousel {
    _getElementWithUrl(url) {
        if (!url) {
            return;
        }

        if (window.location.href.includes(url)) {
            return this._currentPageNavElement;
        }

        const element = this._mainNavigationRootElement.querySelector(`a[href="${url}"]`);
        if (element) {
            return element.parentElement;
        }
    }

    _highlight(element) {
        if (!element) {
            return;
        }

        element.classList.remove(cssClasses.inactiveMenuItem);
        element.classList.add(cssClasses.activeMenuItem);
    }

    _highlightMenuItem(currentUrl) {
        this._unhighlight(this._getElementWithUrl(this._currentMenuUrl));
        this._highlight(this._getElementWithUrl(currentUrl));

        this._currentMenuUrl = currentUrl;
    }

    _init(nextElements, previousElements) {
        super._init(nextElements, previousElements);

        this._currentPageNavElement = document.querySelector(selectors.actualCurrentNavigationElement);
        this._mainNavigationRootElement = document.getElementById(domIds.mainNavigationRoot);
        this._tutorialItems = this._rootElement.getElementsByClassName(cssClasses.tutorialItem);

        // Probably should use the Tutorial's root element instead.
        document.addEventListener('activePageChanged', this._onActivePageChanged.bind(this));
        document.addEventListener('modalLaunched',  this._onModalLaunched.bind(this));
        document.addEventListener('modalDismissed', this._onModalDismissed.bind(this));
    }

    _initHighlight(pageNumber) {
        const element = this._tutorialItems[pageNumber];
        if (element) {
            this._highlightMenuItem(element.dataset[dataAttrs.menuUrl]);
        } else {
            this._highlightMenuItem(null);
        }
    }

    _onActivePageChanged(event) {
        this._initHighlight(event.detail.currentPage);
    }

    _onModalDismissed() {
        this._unhighlight(this._getElementWithUrl(this._tutorialItems[this._activePage].dataset[dataAttrs.menuUrl]));
        this._highlight(this._currentPageNavElement);
    }

    _onModalLaunched() {
        this._unhighlight(this._currentPageNavElement);
        this._initHighlight(this._activePage);
    }

    _unhighlight(element) {
        if (!element) {
            return;
        }

        element.classList.remove(cssClasses.activeMenuItem);
        element.classList.add(cssClasses.inactiveMenuItem);
    }
}

export default class Tutorials extends Carousels {
    constructor() {
        super(cssClasses.tutorial, Tutorial);
    }
}
